import '@wix/ricos/css/plugin-audio-viewer.global.css';
import '@wix/ricos/css/plugin-button-viewer.global.css';
import '@wix/ricos/css/plugin-collapsible-list-viewer.global.css';
import '@wix/ricos/css/plugin-divider-viewer.global.css';
import '@wix/ricos/css/plugin-file-upload-viewer.global.css';
import '@wix/ricos/css/plugin-gallery-viewer.global.css';
import '@wix/ricos/css/plugin-giphy-viewer.global.css';
import '@wix/ricos/css/plugin-hashtag-viewer.global.css';
import '@wix/ricos/css/plugin-html-viewer.global.css';
import '@wix/ricos/css/plugin-image-viewer.global.css';
import '@wix/ricos/css/plugin-link-viewer.global.css';
import '@wix/ricos/css/plugin-link-preview-viewer.global.css';
import '@wix/ricos/css/plugin-mentions-viewer.global.css';
import '@wix/ricos/css/plugin-social-polls-viewer.global.css';
import '@wix/ricos/css/plugin-spoiler-viewer.global.css';
import '@wix/ricos/css/plugin-table-viewer.global.css';
import '@wix/ricos/css/plugin-vertical-embed-viewer.global.css';
import '@wix/ricos/css/plugin-video-viewer.global.css';

import type { ViewerPlugin } from '@wix/ricos';
import {
  initSpoilersContentState,
  pluginActionButtonViewer as pluginActionButton,
  pluginAudioViewer as pluginAudio,
  pluginCodeBlockViewer as pluginCodeBlock,
  pluginCollapsibleListViewer as pluginCollapsibleList,
  pluginDividerViewer as pluginDivider,
  pluginFileUploadViewer as pluginFileUpload,
  pluginGalleryViewer as pluginGallery,
  pluginGiphyViewer as pluginGiphy,
  pluginHashtagViewer as pluginHashtag,
  pluginHtmlViewer as pluginHtml,
  pluginImageViewer as pluginImage,
  pluginLinkButtonViewer as pluginLinkButton,
  pluginLinkPreviewViewer as pluginLinkPreview,
  pluginLinkViewer as pluginLink,
  pluginMentionsViewer as pluginMentions,
  pluginPollViewer as pluginPoll,
  pluginSpoilerViewer as pluginSpoiler,
  pluginTableViewer as pluginTable,
  pluginTextColorViewer as pluginTextColor,
  pluginTextHighlightViewer as pluginTextHighlight,
  pluginVerticalEmbedViewer as pluginVerticalEmbed,
  pluginVideoViewer as pluginVideo,
  SpoilerViewerWrapper,
} from '@wix/ricos';
import type { ViewerPluginName } from '@wix/ricos/schema-next';

import { SocialPollsServiceMock } from './mocks/SocialPollsServiceMock';
import {
  styleSelectionPredicate,
  viewerCustomBackgroundStyleFn,
  viewerCustomForegroundStyleFn,
} from './mocks/text-color-style-fn';

export const viewerPlugins: Record<ViewerPluginName, ViewerPlugin> = {
  image: pluginImage(),
  gallery: pluginGallery({ scopingId: 'ricos-viewer' }),
  video: pluginVideo(),
  poll: pluginPoll({
    onBeforeVote() {
      return Promise.resolve();
    },
    pollServiceApi: new SocialPollsServiceMock(),
    getSiteMembers: (memberIds: string[]) => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(
            [
              // Public user
              {
                siteMemberId: 'd0d683f9-81b1-4ec2-84ee-7f49c5245148',
                name: { nick: 'User 1' },
                imageUrl: 'https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg',
              },
              // Private user
              {
                siteMemberId: 'd0d683f9-81b1-4ec2-84ee-7f49c5245149',
              },
            ].filter(member => memberIds.includes(member.siteMemberId))
          );
        }, 0);
      });
    },
  }),
  divider: pluginDivider(),
  spoiler: pluginSpoiler({ initSpoilersContentState, SpoilerViewerWrapper }),
  table: pluginTable(),
  collapsibleList: pluginCollapsibleList(),
  audio: pluginAudio(),
  html: pluginHtml(),
  link: pluginLink({
    // eslint-disable-next-line no-console
    onClick: (event, url) => console.log('link clicked!', url),
    siteUrl: 'http://localhost:6006/', //siteUrl is for anchor SEO
  }),
  hashtag: pluginHashtag({
    onClick: (event, text) => {
      event.preventDefault();
      // eslint-disable-next-line no-console
      console.log(`'${text}' hashtag clicked!`);
    },
    createHref: decoratedText => `/search/posts?query=${encodeURIComponent('#')}${decoratedText}`,
  }),
  mentions: pluginMentions({
    // eslint-disable-next-line no-console
    onMentionClick: mention => console.log('onMentionCLick', mention),
  }),
  codeBlock: pluginCodeBlock(),
  giphy: pluginGiphy(),
  file: pluginFileUpload({
    resolveFileUrl: () => new Promise(resolve => setTimeout(() => resolve('./logo.svg'), 1000)),
    downloadTarget: '_blank',
    adobeAPIKey: '77266adc759d4dc2a9e071e3bde25095',
  }),
  textColor: pluginTextColor({
    styleSelectionPredicate,
    customStyleFn: viewerCustomForegroundStyleFn,
  }),
  textHighlight: pluginTextHighlight({
    styleSelectionPredicate,
    customStyleFn: viewerCustomBackgroundStyleFn,
  }),
  actionButton: pluginActionButton(),
  linkButton: pluginLinkButton(),
  verticalEmbed: pluginVerticalEmbed(),
  linkPreview: pluginLinkPreview(),
} as const;
